import { Button, Col, Divider, Row, Typography } from "antd";
import React, { useEffect } from "react";
import "./index.css";
import {
  Area,
  AreaChart,
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  retriveToken,
  generatePaper,
  fetchStatistics,
  fetchStatisticsComponent,
} from "../../../../services/AuthServices";
// import { statetistics, statetisticsComponent } from "../../../../actions/loginAction";
import { useDispatch, useSelector } from "react-redux";
import { useWindowDimensions } from "../../examPortal/testBoard";
import {
  getGoalGrade,
  getGoalGrades,
  getGrade,
  getGrades,
  getLastThreeTopics,
} from "../../utils";
import { useNavigate } from "react-router-dom";
import Alert from "../../../common/alert";
import {
  setStatistics,
  setStatisticsComponent,
} from "../../../../reducers/loggedinuser";

const { Text } = Typography;

const BarContainer = ({ height, color, label }) => {
  const barStyle = {
    height: `${height}%`,
    backgroundColor: color,
  };

  return (
    <div className="progress">
      <div style={{ zIndex: 20 }} className="barcontainer">
        <div className="bar" style={barStyle}></div>
      </div>
    </div>
  );
};

const CustomBar = (props) => {
  const { x, y, width, height, color1, color2 } = props;

  let fillColor = "#18A0FB"; // Default fill color

  if (
    props?.payload?.name === "MONTHLY AVG." &&
    props?.payload?.paper === "paper1"
  ) {
    fillColor = color1;
  } else if (
    props?.payload?.name === "MONTHLY AVG." &&
    props?.payload?.paper === "paper2"
  ) {
    fillColor = color2;
  }

  return (
    <g>
      <rect
        x={x}
        y={y}
        width={60}
        height={height}
        rx={12}
        ry={12}
        fill={fillColor}
      />
    </g>
  );
};

const SubjectStatetistics = ({ title, id }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const { statistics, statisticsComponent, user } = useSelector(
    (state) => state.auth
  );
  // console.log(statistics?.data);
  // console.log(statisticsComponent);

  const { paper1, paper2 } = getGoalGrades(
    getGrades(statistics?.data?.goal, statistics?.data?.level),
    title
  );

  // const data = [
  //   {
  //     name: "MONTHLY AVG.",
  //     value: faker.datatype.number({ min: 0, max: 100 }),
  //     paper: "paper1"
  //   },
  //   {
  //     name: "ALL-TIME AVG.",
  //     value: faker.datatype.number({ min: 0, max: 100 }),
  //     paper: "paper1"
  //   },
  //   { name: "", value: 0 },
  //   {
  //     name: "MONTHLY AVG.",
  //     value: faker.datatype.number({ min: 0, max: 100 }),
  //     paper: "paper2"
  //   },
  //   {
  //     name: "ALL-TIME AVG.",
  //     value: faker.datatype.number({ min: 0, max: 100 }),
  //     paper: "paper2"
  //   },
  // ];

  const handleGeneratePaper = (paper) => {
    const topics = getLastThreeTopics(statistics?.data?.weakestTopics);
    const currentDate = new Date();
    const options = { hour: "numeric", minute: "numeric", hour12: false };
    const formattedDate = `${
      user.name
    }-${currentDate.toLocaleDateString()}-${currentDate.toLocaleTimeString(
      [],
      options
    )}`;
    const token = retriveToken();

    if (token && token !== "undefined" && title) {
      generatePaper(token, title, topics, paper, formattedDate)
        .then((response) => {
          // console.log(response);
          if (response.data.success) {
            navigate("/user/livetest");
          }
        })
        .catch((error) => {
          Alert(
            "message",
            "Message!",
            "No Questions to create worksheet in this topic"
          );
        });
    }
  };

  useEffect(() => {
    const token = retriveToken();

    if (token && token !== "undefined" && title) {
      fetchStatistics(token, title).then((response) => {
        //  console.log(response.data);
        dispatch(setStatistics(response.data));
      });
      fetchStatisticsComponent(token, title).then((response) => {
        //  console.log(response);
        dispatch(
          setStatisticsComponent({
            payload: response.data.data,
            payload1: response.data.dataObj,
          })
        );
      });
    } else {
      navigate("/");
    }
  }, [title]);

  return (
    <Row
      style={{
        maxWidth: "1500px",
        margin: "auto",
        marginTop:40
      }}
      gutter={[16, 16]}
    >
      <Col xs={24} md={14}>
        <div className="wrapperBoxState">
          <Text className="titleBox">TOPICAL STATISTICS</Text>
          <div className="subjectTopicContainer">
            <Text className="avgTopicsText">Avg. (%) Breakdown of Topics</Text>
            {statistics?.data?.topicalStatistics?.length !== 0 ? (
              <div style={{ position: "relative", height: "140px" }}>
                <div className="containerState">
                  {statistics?.data?.topicalStatistics?.map((item, index) => (
                    <div className="barParrent" key={index}>
                      <BarContainer
                        height={item?.value}
                        color={
                          item.value <= statistics?.data?.goal &&
                          item.value > 45
                            ? "#FAFF1C"
                            : item.value >= statistics?.data?.goal &&
                              item.value > 45
                            ? "#67FF0B"
                            : item.value < 45
                            ? "red"
                            : "red"
                        }
                        label={item.topic}
                      />
                      <div className="bar-label">{item.topic}</div>
                      <div className="bar-details-box">
                        <div style={{ display: "flex", gap: "4px" }}>
                          <Text className="topicBarHoverText">Topic:</Text>
                          <Text className="topicBarHoverText">
                            {item.topic}
                          </Text>
                        </div>
                        <div style={{ display: "flex", gap: "4px" }}>
                          <Text className="topicBarHoverText">Percentage:</Text>
                          <Text className="topicBarHoverText">
                            {item.value}%
                          </Text>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    position: "absolute",
                    bottom: `${
                      statistics?.data?.goal
                        ? statistics?.data?.goal * 0.84 + "%"
                        : "0%"
                    }`,
                    width: "100%",
                    right: -30,
                    zIndex: 10,
                  }}
                >
                  <div className="dashed_border" />
                  <Text
                    style={{
                      fontSize: "14px",
                      color: "white",
                      marginTop: "12px",
                    }}
                  >
                    Goal
                  </Text>
                </div>
              </div>
            ) : (
              <Text style={{ color: "white", textAlign: "center" }}>
                No Data Found
              </Text>
            )}
          </div>
        </div>
      </Col>
      <Col xs={24} md={10}>
        <div className="wrapperBoxState1">
          <Text className="titleBox">TOPICAL ANALYSIS</Text>
          <Row gutter={24}>
            <Col xs={12}>
              <div
                style={{ display: "flex", flexDirection: "column", gap: "6px" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={{
                        backgroundColor: "white",
                        width: "4px",
                        height: "5px",
                        borderRadius: "4px",
                      }}
                    />
                    <Text className="topicHeading">Strongest Topics</Text>
                  </div>
                  <Text className="topicHeading">Avg.</Text>
                </div>
                {statistics?.data?.strongestTopics?.length !== 0 ? (
                  statistics?.data?.strongestTopics?.map((item, index) => (
                    <React.Fragment key={index}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{ display: "flex", gap: "2px", width: "80%" }}
                        >
                          <Text className="topicText1">{index + 1}.</Text>
                          <Text className="topicText">{item.topic}</Text>
                        </div>
                        <Text className="topicText1">{item.value}%</Text>
                      </div>
                      <Divider className="dividerState" />
                    </React.Fragment>
                  ))
                ) : (
                  <Text style={{ color: "white", textAlign: "center" }}>
                    No Data Found
                  </Text>
                )}
              </div>
            </Col>
            <Col xs={12}>
              <div
                style={{ display: "flex", flexDirection: "column", gap: "6px" }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={{
                        backgroundColor: "white",
                        width: "4px",
                        height: "5px",
                        borderRadius: "4px",
                      }}
                    />
                    <Text className="topicHeading">Weakest Topics</Text>
                  </div>
                  <Text className="topicHeading">Avg.</Text>
                </div>
                {statistics?.data?.weakestTopics?.length !== 0 ? (
                  statistics?.data?.weakestTopics?.map((item, index) => (
                    <React.Fragment key={index}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{ display: "flex", gap: "4px", width: "80%" }}
                        >
                          <Text className="topicText1">{index + 1}.</Text>
                          <Text className="topicText">{item.topic}</Text>
                        </div>
                        <Text className="topicText1">{item.value}%</Text>
                      </div>
                      <Divider className="dividerState" />
                    </React.Fragment>
                  ))
                ) : (
                  <Text style={{ color: "white", textAlign: "center" }}>
                    No Data Found
                  </Text>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </Col>
      <Col xs={24} md={14}>
        <div className="wrapperBoxStateComponenet">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text className="titleBox">COMPONENT ANALYSIS | MONTHLY</Text>
            <Text style={{ fontSize: "12px" }} className="titleBox">
              Goal ----
            </Text>
          </div>
          <div
            style={{
              width: "100%",
              margin: "auto",
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <Text className="paperTest">
              {title === "Mathematics" ? "PAPER 1" : "Booklet A"}
            </Text>
            <Text className="paperTest">
              {title === "Mathematics" ? "PAPER 2" : "Booklet B"}
            </Text>
          </div>
          <div style={{ width: "90%", margin: "auto" }}>
            <Divider />
          </div>
          <div style={{ position: "relative" }}>
            <div
              style={{
                width: "100%",
                height: "170px",
                marginLeft: "-30px",
                marginBottom: "-30px",
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={statisticsComponent?.data}>
                  <XAxis
                    dataKey="name"
                    tick={{ fill: "white" }}
                    angle={width > 1140 ? 0 : -25}
                    interval={0}
                    style={{ fontSize: width > 1390 ? "10px" : "6px" }}
                    width="100%"
                  />
                  <YAxis tick={{ fill: "white" }} domain={[0, 100]} />
                  <Tooltip cursor={{ fill: "transparent" }} />
                  <CartesianGrid stroke="#7E7E7E" vertical={false} />
                  <ReferenceLine y={0} stroke="white" />
                  <ReferenceLine
                    stroke="white"
                    strokeDasharray="9 9"
                    size={2}
                    segment={[
                      { x: "MONTHLY AVG. P1", y: paper1 },
                      { x: "", y: paper1 },
                    ]}
                  />
                  <ReferenceLine
                    stroke="white"
                    strokeDasharray="9 9"
                    size={2}
                    segment={[
                      { x: "", y: paper2 },
                      { x: "ALL-TIME AVG. P2", y: paper2 },
                    ]}
                  />
                  <Bar
                    dataKey="value"
                    radius={[12, 12, 0, 0]}
                    barSize={60}
                  >
                    {statisticsComponent?.data?.map((entry, index) => {
                      let fillColor = "#18A0FB";
                      if (entry?.name === "MONTHLY AVG. P1" && entry?.paper === "paper1") {
                        fillColor =
                          statisticsComponent?.dataObj?.paper1PercentageLast30Days?.value <
                          statistics?.data?.goal &&
                          statisticsComponent?.dataObj?.paper1PercentageLast30Days?.value > 45
                            ? "#FAFF1C"
                            : statisticsComponent?.dataObj?.paper1PercentageLast30Days?.value >=
                              statistics?.data?.goal &&
                              statisticsComponent?.dataObj?.paper1PercentageLast30Days?.value > 45
                            ? "#67FF0B"
                            : statisticsComponent?.dataObj?.paper1PercentageLast30Days?.value < 45
                            ? "red"
                            : "red";
                      } else if (entry?.name === "MONTHLY AVG. P2" && entry?.paper === "paper2") {
                        fillColor =
                          statisticsComponent?.dataObj?.paper2PercentageLast30Days?.value <
                          statistics?.data?.goal &&
                          statisticsComponent?.dataObj?.paper2PercentageLast30Days?.value > 45
                            ? "#FAFF1C"
                            : statisticsComponent?.dataObj?.paper2PercentageLast30Days?.value >=
                              statistics?.data?.goal &&
                              statisticsComponent?.dataObj?.paper2PercentageLast30Days?.value > 45
                            ? "#67FF0B"
                            : statisticsComponent?.dataObj?.paper2PercentageLast30Days?.value < 45
                            ? "red"
                            : "red";
                      }
                      return <Cell key={`cell-${index}`} fill={fillColor} />;
                    })}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </Col>
      <Col xs={24} md={10}>
        <div className="wrapperBoxState1">
          <Text style={{ textAlign: "center" }} className="titleBox">
            GENERATE WORKSHEET
          </Text>
          <Divider />
          <div
            style={{ display: "flex", flexDirection: "column", gap: "36px" }}
          >
            <Text className="paraBox">
              Uses analysis of student’s prior assessment to generate a
              worksheet that targets the student’s weaknesses. Generate a
              worksheet for either Paper 1 or Paper 2.
            </Text>
            <div className="buttonBox">
              <Button
                className="paperButton"
                type="primary"
                onClick={() =>
                  handleGeneratePaper(
                    title === "Mathematics" ? "Paper 1" : "Paper 1 Booklet A"
                  )
                }
              >
                {title === "Mathematics" ? "PAPER 1" : "Booklet A"}
              </Button>
              <Button
                className="paperButton"
                type="primary"
                onClick={() =>
                  handleGeneratePaper(
                    title === "Mathematics" ? "Paper 2" : "Paper 2 Booklet B"
                  )
                }
              >
                {title === "Mathematics" ? "PAPER 2" : "Booklet B"}
              </Button>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default SubjectStatetistics;
